import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'

const signalrUrl = window.config ? window.config.signalrUrl : ''
const wsdl = `${signalrUrl}/astech.svc?wsdl`
const xmlEnvelope = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tns="http://tempuri.org/" xmlns:a="http://tempuri.org/">' +
  ' <soapenv:Body>' +
  '  <tns:SendEvent>' +
  '    <tns:Evt>[[options]]' +
  '    </tns:Evt>' +
  '  </tns:SendEvent>' +
  ' </soapenv:Body>' +
  '</soapenv:Envelope>'

export default {
  async sendEvent({ commit }, xmlOptions) {
    let xml = xmlEnvelope.replace('[[options]]', xmlOptions)
    let settings = {
      method: 'POST',
      headers: {
        'Accept': 'text/xml',
        'Content-Type': 'text/xml'
      },
      body: xml
    }
    let response = await fetch(wsdl, settings)
    return response.text()
  },
  sendStats(stats) {
    http.post(`admin/stats`, stats)
  },
  async pairDevices({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'pairDevices', () =>
      http.post(`Device/PairDevices`, data)
    )
    return r.data
  },
  async unpairDevices({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'unpairDevices', () =>
      http.get(`Device/UnpairDevices?serialNumber=${data}`)
    )
    return r.data
  },
  async searchDevices({ commit, dispatch }, search) {
    const r = await startLoading(dispatch, 'searchDevices', () =>
      http.get(`Device/GetSimulatorDevices?search=${search}`)
    )
    commit(types.SET_DEVICES, r.data)
    return r.data
  },
  async getPairInfo({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getPairInfo', () =>
      http.get(`Device/GetPairingForServiceRequest?serviceRequestId=${id}`)
    )
    commit(types.SET_PAIRINFO, r.data)
    return r.data
  },
  async updateStats({ commit, dispatch }, stats) {
    commit(types.SET_DEVICE_STATS, stats)
    // const r = await startLoading(dispatch, 'updateStats', () =>
    //   http.post(`admin/stats?id=${stats.id}`, stats.data)
    // )
    // return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/simulator/actions.js